import { Pipe, PipeTransform } from '@angular/core';

declare global {
  interface String {
    format(args: string[]): string;
  }
}

@Pipe({
  name: 'stringFormat'
})
export class StringFormatPipe implements PipeTransform {
  transform(value: string, args?: string[]): any {
    return value.format.apply(value, args);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/string-format.pipe.ts